import * as bootstrap from "bootstrap";

class newsletter {
  constructor(context) {
    const myModal = new bootstrap.Modal(document.getElementById('newsletterModal'));
    context.querySelectorAll('.btn-newsletter').forEach(element => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        window.renderNewsletter();
        myModal.show();
        return false;
      })
    });
  }
};

export default newsletter;